import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'https://websitesymphony.com';
const DEFAULT_IMAGE = `${SITE}/og-image.jpg`;

const SEO = ({
  title = 'Website Symphony | Custom Web Design, A.I. & Marketing',
  description = 'Website Symphony builds custom, high-converting websites for businesses across the U.S. — including med spas, tattoo shops, medical, legal, eCommerce and more. Get a free estimate today.',
  keywords = 'web design, website design, custom web design, web design for med spas, web design for tattoo shops, eCommerce web design, AI website integration, Miami web design, website development',
  canonical = '/',
  ogImage = DEFAULT_IMAGE,
  schema = null,
  noIndex = false,
}) => {
  const url = `${SITE}${canonical}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Website Symphony" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* AI/LLM discovery */}
      <meta name="author" content="Website Symphony" />
      <meta name="application-name" content="Website Symphony" />
      <meta name="theme-color" content="#2C5F66" />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export const SITE_URL = SITE;
export default SEO;
